























import { defineComponent, ref, watch } from '@vue/composition-api';
import { useState } from '@u3u/vue-hooks';

export default defineComponent({
  props: {
    outlined: Boolean,
    dense: Boolean,
    icon: String,
    rules: Array,
    selectedZones: null,
    readonly: Boolean,
    multiple: Boolean,
    chips: Boolean,
  },
  setup(props, { emit }) {
    const value = ref(null);
    const { zones } = useState(['zones']);

    const emitToParent = (event: any) => {
      emit('selectZonesChanged', event);
    };

    watch(props, () => {
      value.value = props.selectedZones;
    });

    return {
      emitToParent,
      value,
      zones,
    };
  },
});
